/**
 * Utilidades para normalización de documentos de identidad (DNI/NIE).
 */

/**
 * Detecta el tipo de documento a partir del valor del DNI/NIE.
 * Los NIE empiezan por X, Y o Z; todo lo demás se considera DNI.
 *
 * @param {string} dni
 * @returns {'NIE'|'DNI'}
 */
export function detectarTipoDocumento(dni) {
    if (!dni) return 'DNI';
    const first = String(dni).trim().toUpperCase().charAt(0);
    return ['X', 'Y', 'Z'].includes(first) ? 'NIE' : 'DNI';
}
